import React, { useState } from "react";
import { Layout } from "components";
import styles from "./unsubscribe.module.scss";
import { Footer } from "components/Footer";
import { useHistory } from "react-router-dom";
import UserManager from "commons/utils/Auth/UserManager";
import { login } from "commons/utils/Utils";
import WishlistService from "services/wishListService";

export function Unsubscribe() {
    const history = useHistory();
    const [reason, setReason] = useState("");
    const [justify, setJustify] = useState("");

    const reasons = {
        first: "Os produtos não são o que eu esperava.",
        second: "Não é relevante pra mim no momento.",
        third: "Estou recebendo muitos e-mails de alertas.",
        fourfh: "Eu nunca me inscrevi para receber estes alertas.",
        other: "Outro motivo"
    }

    const handleUnsubscribe = async () => {
        try {
            const wishListService = new WishlistService();
            await wishListService.deleteAllAlertsWishList({reason: reason});
            history.push('/unsubscribe/finished')
        } catch (error) {
            console.log(error);
        }
    }


    React.useEffect(() => {
        if (!UserManager.isLogin()) {
            window.location.href = login();
        }
    }, []);

    return (
        <>
            <Layout title={`Ajude-nos a melhorar.`} subtitle={`Porque deseja se descadastrar?`}>
                <form action="#" style={{ marginLeft: 60 }}>
                    <input
                        onChange={(e)=>setReason(e.currentTarget.value)}
                        type="radio"
                        id="first"
                        checked={reason===reasons.first}
                        name="reason"
                        value={reasons.first}
                        className={styles['inpRadio']}
                    />
                        <label htmlFor="first" className={styles['text-reason']}>{reasons.first}</label>
                    <br />
                    <input
                        onChange={(e)=>setReason(e.currentTarget.value)}
                        type="radio"
                        style={{ marginTop: 18 }}
                        id="second"
                        checked={reason===reasons.second}
                        name="reason"
                        value={reasons.second}
                        className={styles['inpRadio']}
                    />
                        <label htmlFor="second" className={styles['text-reason']}>{reasons.second}</label>
                    <br />
                    <input
                        onChange={(e)=>setReason(e.currentTarget.value)}
                        type="radio"
                        id="third"
                        style={{ marginTop: 18 }}
                        checked={reason===reasons.third}
                        className={styles['inpRadio']}
                        name="reason"
                        value={reasons.third}
                    />
                        <label htmlFor="third" className={styles['text-reason']}>{reasons.third}</label>
                    <br />
                    <input
                        onChange={(e)=>setReason(e.currentTarget.value)}
                        type="radio"
                        id="fourfh"
                        style={{ marginTop: 18 }}
                        checked={reason===reasons.fourfh}
                        name="reason"
                        value={reasons.fourfh}
                        className={styles['inpRadio']}
                    />
                        <label htmlFor="fourfh" className={styles['text-reason']}>{reasons.fourfh}</label>
                    <br />
                    <input
                        onChange={(e)=>setReason(e.currentTarget.value)}
                        type="radio"
                        id="other"
                        style={{ marginTop: 18 }}
                        checked={reason===reasons.other}
                        name="reason"
                        value={reasons.other}
                        className={styles['inpRadio']}
                    />
                        <label htmlFor="other" className={styles['text-reason']}>{reasons.other}</label><br />
                        {reason===reasons.other ? <input
                            className={styles['inp-justify']}
                            onChange={(e)=>setJustify(e.currentTarget.value)}
                            value={justify}
                            type="text"
                            placeholder="Descreva o motivo (opcional)"
                        /> : null}

                    <button
                        className={styles['btn-unsubscribe']}
                        onClick={handleUnsubscribe}
                        type="button"
                        disabled={reason===""}
                    >
                        Descadastrar
                    </button>

                    <p className={styles['text-manager-alerts']}>
                        Você também pode <span onClick={() => history.push('/') }>gerenciar seus alertas.</span>
                    </p>
                </form>
            </Layout>
            <Footer />
        </>
    );
}
